"use strict";
// @ts-ignore
new Splide('.banner-splide', {
    perPage: 1,
    perMove: 1,
    type: 'slide',
    gap: "0px",
    pagination: true,
    arrows: true
}).mount();
check();
window.addEventListener('resize', function () {
    check();
});
function check() {
    var windowWidth = window.innerWidth;
    var imageSlides = document.querySelectorAll('.banner-splide .splide__slide .image');
    if (windowWidth > 767) {
        // Desktop
        imageSlides.forEach(function (imageSlide) {
            var desktopUrl = imageSlide.getAttribute('data-desktop');
            imageSlide.style.backgroundImage = "url(".concat(desktopUrl, ")");
        });
    }
    else {
        // Mobile
        imageSlides.forEach(function (imageSlide) {
            var mobileUrl = imageSlide.getAttribute('data-mobile');
            imageSlide.style.backgroundImage = "url(".concat(mobileUrl, ")");
        });
    }
}
